import { observe } from 'mobx';
import { useState, useEffect } from 'react';
import { i18NextStore, I18NextStore } from './store';

type UpdateType = 'new' | 'update';

type I18NextStoreType = {
	type: UpdateType;
	store: I18NextStore;
};

export function useI18NextStore(): [I18NextStoreType] {
	const [_i18NextStore, setI18NextStore] = useState<I18NextStoreType>({
		type: 'new',
		store: i18NextStore
	});

	useEffect(() => {
		const disposer = observe(i18NextStore, () => {
			setI18NextStore({
				type: 'update',
				store: i18NextStore
			});
		});

		return () => disposer();
	}, []);

	return [_i18NextStore];
}
